import React, { useCallback, useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { RadioGroupStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"

const medicallyNecessaryOptions = [
  { label: defineMessage({ defaultMessage: "Yes" }), value: "YES" },
  { label: defineMessage({ defaultMessage: "No" }), value: "NO" }
]

export function CareConsideredMedicallyNecessaryFertilityStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isMedicallyNecessary, isInfertilityDx },
    serverState: { hasElectiveFertilityCareCoverage, hasInfertilityDxCoverage }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const formattedOptions = useConvertTranslatedLabel(medicallyNecessaryOptions) as FormSelectOption[]

  const onSubmit = useCallback(
    (formValues: { [key: string]: string }): void => {
      dispatchFormState({
        type: "UPDATE_FIELD",
        field: "isMedicallyNecessary",
        value: formValues.isMedicallyNecessary
      })
      if (hasElectiveFertilityCareCoverage && hasInfertilityDxCoverage) {
        send("YES")
        return
      }
      if (
        !hasElectiveFertilityCareCoverage &&
        hasInfertilityDxCoverage &&
        (isInfertilityDx === "YES" || formValues.isMedicallyNecessary === "YES")
      ) {
        send("YES")
        return
      }
      if (
        hasElectiveFertilityCareCoverage &&
        !hasInfertilityDxCoverage &&
        isInfertilityDx === "NO" &&
        formValues.isMedicallyNecessary === "NO"
      ) {
        send("YES")
        return
      }
      send("NO")
    },
    [dispatchFormState, hasElectiveFertilityCareCoverage, hasInfertilityDxCoverage, isInfertilityDx, send]
  )

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Is the care considered medically necessary by an eligible fertility provider?"
      })}
      description={intl.formatMessage({
        defaultMessage:
          "If you're not sure, ask your provider. This helps us determine if the care may be a qualified medical expense."
      })}
      name="isMedicallyNecessary"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isMedicallyNecessary}
    />
  )
}
